import React from 'react';
import PropTypes from 'prop-types';

const InlineScript = (props) => {
  const ctnId = `inline-script-container-${React.useId()}`;

  React.useEffect(() => {
    const pps = props.attribs;
    const el = document.getElementById(ctnId);
    let scpt;
    if (pps.src) {
      if (el) {
        scpt = document.createElement('script');
        for(const pp in pps) {
          scpt[pp] = pps[pp];
        }
        el.appendChild(scpt);
      }
    }

    return () => {
      if (el && scpt) {
        el.removeChild(scpt);
        el.innerHTML = '';
      }
    };
  }, [props.attribs, ctnId]);
  return <div id={ctnId}></div>;
};

InlineScript.propTypes = {
  attribs: PropTypes.object.isRequired,
};

export default InlineScript;